import {CanActivateTeamDecisionsGuard} from '../guards/can-activate-team-decisions.guard';
import {CanDeactivateModificationComponentGuard} from '../../guards/can-deactivate-modification-component.guard';
import {PlayerStaffDecisionComponent} from './player-staff-decision/player-staff-decision.component';
import {StaffDecisionComponent} from './staff-decision.component';
import {AnimatorStaffMarksComponent} from './animator-staff-marks/animator-staff-marks.component';
import {CanActivateAnimatorGuard} from '../guards/can-activate-animator.guard';
import {IsNotSimulationOrRevertStartedGuard} from '../guards/is-not-simulation-or-revert-started-guard.service';
import {mapToCanActivate, mapToCanDeactivate} from '@angular/router';

export const staffDecisionRoute = {
    path: 'staff',
    component: StaffDecisionComponent,
    canActivate: mapToCanActivate([CanActivateTeamDecisionsGuard, IsNotSimulationOrRevertStartedGuard]),
    canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard]),
    children: [
        {
            path: '',
            component: PlayerStaffDecisionComponent,
            canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
        },
        {
            path: 'mark',
            component: AnimatorStaffMarksComponent,
            canActivate: mapToCanActivate([CanActivateAnimatorGuard]),
            canDeactivate: mapToCanDeactivate([CanDeactivateModificationComponentGuard])
        }
    ]
};
